export type ClassValue = string | false | null | undefined;

/**
 * Join class names, dropping anything falsy.
 *
 * Deliberately tiny: the UI primitives compose fixed variant strings rather
 * than merging conflicting utilities, so no `tailwind-merge` is needed.
 */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
